
import * as ipxRuntime$vU30RJb1Si from '/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 90
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$vU30RJb1Si, defaults: {} }
}
        